module.exports = __webpack_public_path__ + "img/top.fc25f408.png";